import { useNavigate, useParams } from 'react-router-dom';
import './missionConfigNew.css'
import Loader from '../../Layouts/Loader/Loader';
import { useState } from 'react';
import { checkCommonNameValidation, checkDecimal, getCharacterLimitMessage, navigateTo, onKeyDown } from '../../utils/commonFunctions';
import MissionService from '../../service/MissionService';
import { MissionStore, setMissionEdit, setMission } from '../../store/MissionSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import ConfirmationDialog from '../CommonComponents/confirmation_dialog/ConfirmationDialog';
import { showToastMessage } from '../../utils/commonFunctions';

const MissionConfigNew = () => {
    const params = useParams()
    const { project_id, mission_id, mission_name } = params
    const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);
    const MISSION_OBJECTIVE = ['Earth Observation', 'Communication', 'Other']
    const missionEdit = useSelector(
        (state: { mission: MissionStore }) => state.mission.missionEdit
    );
    const [missionIdEditCase, setMissionIdEditCase] = useState("")
    const dispatch = useDispatch();
    const [projectIdEditCase, setProjectIdEditCase] = useState("")
    const [isShowModal, setIsShowModal] = useState(false)
    const [missionInfo, setmissionInfo] = useState({})

    const [loading, setLoading] = useState(false)
    let navigate = useNavigate();

    const [missionData, setMissionData] = useState({
        title: '',
        summary: '',
        objective: 'Earth Observation',
        life: ''
    })

    const get_mission = () => {
        setLoading(true)
        MissionService.get_mission_by_id(mission_id)?.then((res) => {
            if (res.data) {
                setmissionInfo(res.data)
                setMissionIdEditCase(res.data?.uniqueId)
                setProjectIdEditCase(res?.data?.projectId)
                dispatch(setMission(res.data))
                dispatch(setMissionEdit(true))
                setMissionData({
                    title: res?.data?.missionTitle,
                    summary: res?.data?.summary,
                    objective: res?.data?.missionObjective,
                    life: res?.data?.missionLife
                })
            }
            else {
                navigateTo(`${missionData.title}/_details/${mission_id}/${'Satellites'}`, navigate)
                showToastMessage('error', "Something went wrong while updating mission")
            }
            setLoading(false)
        }).catch((err) => {
            console.error(err);
            navigate(-1);
            setLoading(false)
            showToastMessage('error', "Something went wrong")
        })
    }

    const validateMissionInfo = (data) => {
        if (!data?.missionTitle || data?.missionTitle.trim() === "") {
            showToastMessage('info', "Please enter a valid mission title");
            return false;
        } else if (data?.missionLife === "" || !data?.missionLife) {
            showToastMessage('info', "Please enter the mission life")
            return false;
        }
        return true;
    }

    useEffect(() => {
        if (mission_id) {
            get_mission()
        }
    }, [mission_id])

    const createMission = () => {
        const data = {
            "missionLife": parseFloat(missionData.life),
            "missionTitle": missionData.title,
            "missionObjective": missionData.objective,
            "projectId": missionEdit ? projectIdEditCase : project_id,
            "summary": missionData.summary
        }
        const valid = validateMissionInfo(data);
        if (valid) {
            setLoading(true)
            if (missionEdit) {
                const updated_mission = {
                    ...missionInfo,
                    "missionLife": parseFloat(missionData.life),
                    "missionTitle": missionData.title,
                    "missionObjective": missionData.objective,
                    "projectId": missionEdit ? projectIdEditCase : project_id,
                    "summary": missionData.summary,
                }
                MissionService.updateMission(mission_id, updated_mission)?.then((res) => {
                    if (res) {
                        dispatch(setMission(updated_mission))
                        dispatch(setMissionEdit(false))
                        showToastMessage('success', 'Mission updated successfully');
                        navigateTo(``, navigate)
                    }
                }).catch(err => {
                    showToastMessage('error', 'Something went wrong while updating mission')
                }).finally(() => {
                    setLoading(false)
                })
            } else {
                MissionService.createMission(data)?.then((res) => {
                    if (res) {
                        const missionId = res?.data?.missionId
                        showToastMessage('success', 'Mission created successfully');
                        const navigationPath = userData?.['feature-allowed']?.['missionModelling'] === 'Yes'
                            ? `${missionData.title}/_details/${missionId}/${'Modelling'}`
                            : `${missionData.title}/_details/${missionId}/${'Satellites'}`;
                        navigateTo(navigationPath, navigate) // Navigations to Mission Screen After API Success
                    }
                }).catch(err => {
                    if (err === 'Mission Already exists') {
                        showToastMessage('error', err)
                    } else {
                        showToastMessage('error', "Something went wrong while creating mission")
                    }
                }).finally(() => {
                    setLoading(false)
                })
            }
        }
    }

    return (
        <div className='w-100 h-100 overflow-hidden d-flex align-items-center justify-content-center'>
            {loading && <Loader />}
            <div className='create_mission_container'>
                <div className='mission_heading'>
                    {missionEdit ? 'Update' : 'New'} Mission
                </div>
                <div className="separator" />
                <div className='horizontal_container'>
                    <div className='field_container'>
                        <span className=''>Title * </span>
                        <input
                            className='input_field'
                            value={missionData.title}
                            onChange={(e) => {
                                e.preventDefault();
                                if (!checkCommonNameValidation(e.target.value, 26)) return
                                setMissionData({
                                    ...missionData,
                                    title: e.target.value.trimStart()
                                })
                            }}
                            placeholder='Title'
                        />
                    </div>
                    <div className='field_container'>
                        <span> Summary </span>
                        <input
                            className='input_field'
                            value={missionData.summary}
                            placeholder='Summary'
                            onChange={(e) => {
                                if (e.target.value.length > 200) {
                                    showToastMessage('error', getCharacterLimitMessage(200))
                                } else {
                                    setMissionData({
                                        ...missionData,
                                        summary: e.target.value.trimStart()
                                    })
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='horizontal_container'>
                    <div className='field_container'>
                        <span>Objective * </span>
                        <div className='mission_obj_items'>
                            {MISSION_OBJECTIVE?.map((item, index) => (
                                <div
                                    className={`mission_obj_item mo_font ${missionData?.objective === item ? 'selected_mo' : ''}`} key={index}
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        setMissionData({
                                            ...missionData,
                                            objective: e.target.innerText
                                        })
                                    }}
                                >
                                    {item}
                                </div>
                            ))
                            }
                        </div>
                    </div>
                    <div className='field_container'>
                        <span>Life * </span>
                        <input
                            className='input_field'
                            type='number'
                            min={0.1}
                            max={15}
                            step={0.1}
                            value={missionData.life}
                            onKeyDown={onKeyDown}
                            onChange={(e) => {
                                const input = e.target.value;
                                if (Number(input) <= 15) {
                                    if (checkDecimal(input, 2)) { // Allow numbers with up to two decimal places
                                        setMissionData({
                                            ...missionData,
                                            life: input
                                        });
                                    } else {
                                        showToastMessage('info', "Decimal places cannot exceed 2 digits");
                                    }
                                } else {
                                    showToastMessage('info', "Life cannot exceed 15 years");
                                }
                            }}
                            placeholder='Years'
                        />
                    </div>
                </div>

                <div className="separator" />
                <div className='horizontal_container disabled'>
                    <div className='field_container'>
                        <span> Max Total Satellites </span>
                        <input
                            className='input_field'
                            value={userData?.['feature-allowed']?.['noOfSatellitesMaxLimit'] || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='field_container'>
                        <span> Max Running Simulation </span>
                        <input
                            className='input_field'
                            value={userData?.['feature-allowed']?.['noOfSimulationsMaxLimit'] || ''}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="separator" />

                <div className='submission_buttons'>
                    {missionEdit &&
                        <div className='mission_obj_item submit_font cancle_button'
                            onClick={() => {
                                setIsShowModal(true)
                            }}
                        >
                            Close
                        </div>
                    }
                    {!missionEdit && <div />}
                    <div
                        className='mission_obj_item submit_font submit_button align-self-end'
                        onClick={() => {
                            createMission()
                        }}
                    >
                        {missionEdit ? 'Update' : 'Create'}
                    </div>
                </div>
            </div>

            <ConfirmationDialog
                type='cancel'
                open={isShowModal ? true : false}
                title={`Discard Mission Configuration?`}
                description={`Discarding mission configuration flow will take you back to the mission details page.`}
                onCancel={() => setIsShowModal(false)}
                onConfirm={() => {
                    if (missionEdit) {
                        dispatch(setMissionEdit(false))
                        navigateTo(`${mission_name}/_details/${mission_id}/${'Satellites'}`, navigate) // Navigations to Mission Screen After API Success
                    } else {
                        dispatch(setMissionEdit(false))
                        navigateTo(`super_admin_dashboard`, navigate)
                    }
                    setIsShowModal(false);
                }}
                confirm_button_text={`Discard`}
            />
        </div>

    )
};

export default MissionConfigNew